import React from 'react';

function Footer()
{
    return (
        <footer className="bg-gray-800">
            <div className="container mx-auto px-4 p-5">
                <p className="text-center  text-gray-300 text-sm">
                    © 2023 Prabhat Patel. All rights reserved. <a className='text-blue-700' href="https://github.com/i-m-prabhat/Blog-App" target='_blank'>Github</a>
                </p>
            </div>
        </footer>
    );
}

export default Footer;
